import s from "./team.module.css"
import shadowImg from "../../../assets/eagleShadow.png"


export default function Team({ colorFondo }) {
    return (
        <section className={s[colorFondo]}>
            <div className={s.container}>
                <div className={s.contenedorTeam}><span className={s.team}>team</span></div>
                <div className={s.membersContainer}>
                    <div className={s.member}>
                        <div className={s.memberInfo}>
                            <div className={s.nftContainer}><img className={s.img} src={shadowImg} alt="team" /></div>
                        <div className={s.nameContainer}>
                            <span className={s.name}>Mike</span>
                            <span className={s.job}>dev</span>
                        </div>
                        </div>
                        <div className={s[colorFondo+"s"]}><div className={s.exp}>
                            <span className={s.experience}>Experience Solidity Developer for secure smart contract deployment on Ethereum network. Skilled in development, testing, and blockchain technology.</span></div>
                        </div>
                    </div>
                    <div className={s.member}>
                    <div className={s.memberInfo}>
                            <div className={s.nftContainer}><img className={s.img} src={shadowImg} alt="team" /></div>
                        <div className={s.nameContainer}>
                            <span className={s.name}>Shawn</span>
                            <span className={s.job}>Marketer</span>
                        </div>
                        </div>
                        <div className={s[colorFondo+"s"]}>
                            <div className={s.exp}>
                                <span className={s.experience}>Experienced Web3 Marketer specialized in growing major DeFi social media accounts. Skilled in building relationships, strategies, and engagement for Venom Soldiers.</span></div>
                            </div>
                    </div>
                    <div className={s.member}>
                    <div className={s.memberInfo}>
                            <div className={s.nftContainer}><img className={s.img} src={shadowImg} alt="team" /></div>
                        <div className={s.nameContainer}>
                            <span className={s.name}>Sarah</span>
                            <span className={s.job}>Designer</span>
                        </div>
                        </div>
                        <div className={s[colorFondo+"s"]}>
                            <div className={s.exp}>
                                <span className={s.experience}>  Experienced in designing user-centered designs for blockchain-based platforms, digital wallets, and decentralized exchanges. Strong understanding of Web3 principles.</span></div>
                        </div>
                    </div>
                    <div className={s.member}>
                    <div className={s.memberInfo}>
                            <div className={s.nftContainer}><img className={s.img} src={shadowImg} alt="team" /></div>
                        <div className={s.nameContainer}>
                            <span className={s.name}>Nik</span>
                            <span className={s.job}>Artist</span>
                            </div>
                        </div>
                        <div className={s[colorFondo+"s"]}>
                            <div className={s.exp}>
                                <span className={s.experience}>NFT Artist experienced in digital art, blockchain, and crypto art. Skilled in Adobe Creative Suite, Blender, and ZBrush. Successful in creating and selling NFT artworks. Art and technology enthusiast.</span></div>
                        </div>
                    </div>
                    <div className={s.member}>
                    <div className={s.memberInfo}>
                            <div className={s.nftContainer}><img className={s.img} src={shadowImg} alt="team" /></div>
                        <div className={s.nameContainer}>
                            <span className={s.name}>Frankie</span>
                            <span className={s.job}>Project Manager</span>
                            </div>
                        </div>
                        <div className={s[colorFondo+"s"]}>
                            <div className={s.exp}>
                                <span className={s.experience}>Experienced Project Manager with a track record of delivering successful projects on-time and within budget. Strong leadership, organization, and communication skills.</span></div>
                        </div>
                    </div>
                    <div className={s.member}>
                    <div className={s.memberInfo}>
                            <div className={s.nftContainer}><img className={s.img} src={shadowImg} alt="team" /></div>
                        <div className={s.nameContainer}>
                            <span className={s.name}>Pete</span>
                            <span className={s.job}>Community Manager</span>
                            </div>
                        </div>
                        <div className={s[colorFondo+"s"]}>
                            <div className={s.exp}>
                                <span className={s.experience}>Experienced Community Manager with a passion for building and engaging online communities. Skilled in content creation, social media management, and event planning.</span></div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    )
}